import { signal, computed } from "@preact/signals";

const STORAGE_KEY = "__whs_tokens";

export interface AuthUser {
  userId: string;
  accessToken: string;
  refreshToken: string;
  expiresAt: number | null;
}

export const authUser = signal<AuthUser | null>(null);
export const authLoading = signal(true);
export const isAuthenticated = computed(() => authUser.value !== null);
export const tenantId = computed(() => authUser.value?.userId ?? null);

export function startAuthTransition(): void {
  authLoading.value = true;
}

export function setAuth(user: AuthUser): void {
  authUser.value = user;
  authLoading.value = false;
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        accessToken: user.accessToken,
        refreshToken: user.refreshToken,
        userId: user.userId,
        expiresAt: user.expiresAt,
      }),
    );
  } catch {
    // sessionStorage may be unavailable in some contexts
  }
}

export function clearAuth(): void {
  authUser.value = null;
  authLoading.value = false;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // noop
  }
}

export function restoreAuth(): void {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as AuthUser;
      if (parsed.accessToken && parsed.refreshToken && parsed.userId) {
        authUser.value = parsed;
      }
    }
  } catch {
    // corrupted or unavailable
  }
  authLoading.value = false;
}
